// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NTGA","title":"styles_title__1qX8P"};